import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {delayWhen, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {ArrayResponse, BaseEffect, error, SendBackResult} from '../index';
import {Router} from '@angular/router';
import {
  LoadPlayerConfigurationEditFailAction,
  LoadPlayerConfigurationEditSuccessAction,
  playerConfigurationEditActionTypes
} from '../actions/player-configuration-edit';
import {PlayerConfigurationEdit} from '../models/player-configuration';
import {PlayerConfigurationEditService} from '../services/player-configuration-edit.service';
import * as _ from 'lodash';
import * as fromRoot from '../reducers';
import * as fromSite from '../../site/reducers';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class PlayerConfigurationEditEffect extends BaseEffect {

  private currentClient$ = this.store.pipe(select(fromRoot.selectors.getCurrentClient), filter(client => !_.isEmpty(client)));
  private site$ = this.store.pipe(select(fromSite.selectors.getSite), filter(state => !_.isEmpty(state)));


  load$ = createEffect(() => { return this.actions$.pipe(ofType(playerConfigurationEditActionTypes.LOAD),
    debug('Player Configuration Edit load action received.'),
    delayWhen(() => this.currentClient$),
    delayWhen(() => this.site$),
    withLatestFrom(this.currentClient$, this.site$),
    switchMap(([action, client, site]) => this.playerConfigurationService.getPlayerConfiguration(client.uuid, site.subscriptions[0].uuid).pipe(
      map((resp: SendBackResult<ArrayResponse<PlayerConfigurationEdit>>) => new LoadPlayerConfigurationEditSuccessAction(this.getUniqValues(resp.data.array)))))
  ) });

  loadClient$ = createEffect(() => { return this.actions$.pipe(ofType(playerConfigurationEditActionTypes.LOAD_CLIENT),
    debug('Player Configuration Edit load action received.'),
    delayWhen(() => this.currentClient$),
    withLatestFrom(this.currentClient$),
    switchMap(([action, client]) => this.playerConfigurationService.getPlayerConfigurationClient(client.uuid).pipe(
      map((resp: SendBackResult<ArrayResponse<PlayerConfigurationEdit>>) => new LoadPlayerConfigurationEditSuccessAction(this.getUniqValues(resp.data.array)))))
  ) });


 /* loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(playerConfigurationEditActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Player Configuration Edit list.'),
    map((action: LoadPlayerConfigurationEditFailAction) =>
      error(this.translation.translate('PLAYER_CONFIGURATION_EDIT_LOAD_ERROR'), this.translation.translate('TOAST_ERROR_TITLE'))))
  });*/

  protected handleUnhandledError = (response) => {
    return new LoadPlayerConfigurationEditFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadPlayerConfigurationEditFailAction(response['error'].message);
  }

  constructor(router: Router,
              private actions$: Actions,
              private translation: L10nTranslationService,
              private playerConfigurationService: PlayerConfigurationEditService,
              private store: Store<fromRoot.AppState>) {
    super(router);
  }

  getUniqValues(data: PlayerConfigurationEdit[]): PlayerConfigurationEdit[] {
    return _.uniqBy(data, 'name');
  }
}
